import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable()
export class MonitoringInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.cookieService.check('MonitoringId')) {
      request = request.clone({
        setHeaders: {
          'Monitoring-Id': this.cookieService.get('MonitoringId'),
        },
      });
    }
    return next.handle(request);
  }
}
